import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as api from "../../../api";
import MyMessageCardRow from './MyMessageCardRow';
import Button from "../../../storybook/Button";
import { selectedTabValue, userNavigatedFrom } from '../../../ducks/redux/actions/userChoices';
import { useDispatch } from "react-redux";
import Message from "../../../storybook/Message";
import { detectMobile } from "../../../utils/formatting";
interface MyMessagesCardProps extends RouteComponentProps { associatedAssetList: any }
const MyMessagesCard: React.FC<MyMessagesCardProps> = (props) => {
    const { t } = useTranslation();
    const customerID = useSelector((state: any) => state.addresses?.customerid);
    const PropertyId = useSelector((state: any) => state.userChoicesReducer?.userChosenPropertyId);
    const allassetIndentifiers = useSelector((state: any) => state?.userChoicesReducer?.allassetIdentifiers)
    const isEicrCardToggle = useSelector((state: any) => state?.userChoicesReducer?.isEICRCardToggle)
    const isGasCardToggle = useSelector((state: any) => state?.userChoicesReducer?.isGASCardToggle)

    const [allMyMessages, setAllMyMessages] = React.useState<any>();
    const [gasBoilerAlert, setGasBoilerAlert] = React.useState("");
    const [EICRAlert, setEICRAlert] = React.useState("");
    const [yellowAlertMessage, setYellowAlertMessage] = React.useState('');
    const formatedToday = new Date().toISOString().split("T")[0];
    const twoYearsAgoFromNow = new Date();
    twoYearsAgoFromNow.setFullYear(twoYearsAgoFromNow.getFullYear() - 2);
    const formatedTwoYearsAgo = twoYearsAgoFromNow.toISOString().split("T")[0];
    const sessionId = localStorage.getItem("sessionId");
    const corelationId = localStorage.getItem("corelationId");
    const customerId = localStorage.getItem("customerId");
    const [alertMessage, setAlertMessage] = React.useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        if (sessionId !== null && corelationId !== null && customerId !== null) {

            (async () => {
                const requestData = {
                    fromDate: formatedTwoYearsAgo,
                    toDate: formatedToday,
                    status: '',
                    assetIdentifier: allassetIndentifiers,
                    searchText: '',
                    limit: 2,
                    skip: 0,
                    sort: ''
                }
                await api.getCommunicationMessages(customerID, requestData)
                    .then((response) => {
                        if (response?.["total-count"] === undefined || response?.["total-count"] === 0) {
                            setYellowAlertMessage('SSC016');                        
                        } else {
                            setYellowAlertMessage('');
                            if (response['unreadCatagoryTypes']) {
                                if (isGasCardToggle && response['unreadCatagoryTypes'].indexOf('ASSET COMPLIANCE-ANNUALDOMESTICGASSERVICING') > -1) {
                                    setGasBoilerAlert("GasBoiler_ServiceoverDue");
                                } else {
                                    setGasBoilerAlert(""); 
                                }
                                if (isEicrCardToggle && response['unreadCatagoryTypes'].indexOf('ASSET COMPLIANCE-EICR5Y') > -1) {
                                    setEICRAlert("GasBoiler_ServiceoverDue");
                                } else {
                                    setEICRAlert(""); 
                                }
                            }
                        }
                        setAllMyMessages(response);
                    })
                    .catch((error) => {
                        setAlertMessage(true);
                        console.error("Error fetching communication messages:", error);
                    })
            })()
        }
    }, [sessionId, corelationId, customerId, customerID, props.associatedAssetList, PropertyId, allassetIndentifiers, isEicrCardToggle, isGasCardToggle]);

    const callMyMessageHistory = () => {
        dispatch(selectedTabValue("mymessageshistory"));
        dispatch(userNavigatedFrom(""));
        props.history.push("/mymessageshistory");
    };

    const openMobiledialer = () => {
        window.open('tel:' + t('phone_no'));
    };

    const isMobile = detectMobile();
    return (
        <div className="body-card row m-0 border-green display-column">
            <h4 data-testid="My_Messages">
                {" "}
                {t("My_Messages")}{" "}
            </h4>
            {(!alertMessage) ? (
                <div>
                    <div className="col-md-12 p-0">
                        <h5 className="pt-24 pb-20">{t("My_Messages_Sub")}</h5>
                        {(gasBoilerAlert || EICRAlert) && (
                    <div data-testid="gas-alert-warning" className="Gas-Boiler-Service">
                        <Message className="error-msg" data-testid="gas_mymessage_alert">
                            {t(gasBoilerAlert || EICRAlert)}
                        </Message>
                    </div>
                )}
                        {allMyMessages?.communications?.length > 0 &&
                            <div className='p-0'>
                                <div className="flex justify-start">
                                    <div className="pe-2">All ({allMyMessages?.["total-count"]})</div>
                                    <div>Unread ({allMyMessages?.["total-unread"]})</div>
                                </div>
                            </div>
                        }
                        {yellowAlertMessage ?
                            <div><p data-testid="yellow_Notification">{t(yellowAlertMessage)}</p></div> : allMyMessages?.communications?.slice(0, 2).map((eachMsg: any, key: number) => {
                                return (
                                    <MyMessageCardRow
                                        key={key}
                                        eachMsgData={eachMsg}
                                        msgArrayNum={key}
                                        {...props}
                                    />
                                );
                            })
                        }
                    </div>
                    <div className="col-md-12 marginTop-auto">
                        <div className="row pe-0 repair-btn">
                            <div className="col ps-0 pt-30">

                                {allMyMessages?.communications?.length > 0 &&
                                    <div>
                                        <Button onClick={callMyMessageHistory} className="secondary-ghost-btn">View all messages</Button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            ) : (isMobile) ?
                <div className="col-md-12 p-0">
                    <div className='p-0'>
                        <div className="flex justify-start">
                            <Message className="error-msg">{t('message_Card_Alert_Message')} {<span className="underline cursor-pointer" onClick={openMobiledialer} onKeyDown={openMobiledialer}> {t('phone_no')} </span>}
                            </Message>
                        </div>
                    </div>
                </div> : (<div className="col-md-12 p-0">
                    <div className='p-0'>
                        <div className="flex justify-start">
                            <Message className="error-msg">{t('message_Card_Alert_Message')} {<span> {t('phone_no')} </span>}
                            </Message>
                        </div>
                    </div>
                </div>
                )}
        </div>
    );
};
export default MyMessagesCard;